import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Firebase Web API key — by design shipped to the frontend (visible in bundle).
// MUST be restricted in Google Cloud Console:
//   APIs & Services → Credentials → Web API key →
//     - Application restrictions: HTTP referrers → pay.sovo.dev/*, sovo-bd5c0.firebaseapp.com/*, localhost/*
//     - API restrictions: only enable Firebase APIs (Auth, Firestore, Storage, Functions)
// Do NOT enable Generative Language API on this key — that's how it gets abused.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "sovo-bd5c0.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "sovo-bd5c0",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "sovo-bd5c0.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "650918562474",
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

if (!firebaseConfig.apiKey || !firebaseConfig.appId) {
  throw new Error(
    'Missing Firebase config. Create .env.local with REACT_APP_FIREBASE_API_KEY and REACT_APP_FIREBASE_APP_ID.'
  );
}

const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);
const storage = getStorage(app);

export { firestore, storage };
export const auth = getAuth(app);
